<template>
    <div>
        <div class=" max-w-5xl mx-auto">
            <osv-cart-payment />
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
</style>